import React, { useEffect, useState, useRef } from "react";
import team from "../../../../assets/images/homewallpapers/team.jpg";

import gsap from "gsap";
import { useInView } from "react-intersection-observer";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Parallax from "parallax-js";
import { Link } from "react-router-dom";
import ProjectCard from "./projectCard/ProjectCard";
function Project({ data, isLargeScreen, pageInView, setPageInView }) {
    const [hoveredId, setHoveredId] = useState(null);
    const parallaxInstances = useRef({});
    const bgRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (bgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * 0.3; // Adjust the speed of the parallax effect

                gsap.to(bgRef.current, {
                    y: translateY,
                    duration: 0.5, // Duration of the animation
                    ease: "power2.out", // Easing function
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleHover = (item) => {
        if (item) {
            setHoveredId(item.id);

            setTimeout(() => {
                if (!parallaxInstances.current[item.id]) {
                    const element = document.querySelector(
                        `#parallax-container-${item.id}`
                    );
                    if (element) {
                        // Initialize and store the Parallax instance for future reference
                        parallaxInstances.current[item.id] = new Parallax(
                            element
                        );
                    }
                }
            }, 100);
        } else {
            setHoveredId(null);
        }
    };

    useEffect(() => {
        // Cleanup parallax instances on component unmount
        return () => {
            Object.values(parallaxInstances.current).forEach((instance) =>
                instance.destroy()
            );
        };
    }, []);
  const { ref, inView, entry } = useInView({
      /* Set trigger once to true if you only want it to trigger once */
      triggerOnce: false,
      threshold: 0.5, // Adjust this value between 0 and 1 to fine-tune when the callback should trigger
  });
  useEffect(() => {
      if (inView) {
          console.log("pageview is mission");
          if (inView) {
              setPageInView("projects");
          }
      }
  }, [inView]);
    return (
        <div
            ref={ref}
            className="  relative  w-full   flex-col flex justify-center "
            id="projects"
        >
            {" "}
            <div className=" w-[100%] mx-auto z-30   ">
                {data.art.map((item) => (
                    <ProjectCard
                        isLargeScreen={isLargeScreen}
                        item={item}
                        handleHover={handleHover}
                        hoveredId={hoveredId}
                    />
                ))}
            </div>
        </div>
    );
}

export default Project;
